import enhance from './enhancer';
import Overview from './Overview.js';

export default enhance(Overview);
